<template>
  <div class="milestoneMaintenance">
    <el-form :model="milestoneForm" ref="milestoneForm" label-width="0">
      <el-table :data="milestoneForm.tableData" border v-loading="tableLoading" class="milestone-table" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column label=""  width="40" fixed="left">
          <template v-slot="scope" v-if="canEdit">
            <i class="el-icon-circle-plus-outline" style="font-size: 20px; margin-top: 2px;" @click="addRow(scope.$index)" v-if="scope.$index !== milestoneForm.tableData.length - 1"></i>
            <i class="el-icon-remove-outline" style="font-size: 20px;; margin-top: 2px;" @click="deleteRow(scope.row, scope.$index)" v-if="scope.$index !== milestoneForm.tableData.length - 1 && milestoneForm.tableData.length > 2"></i>
          </template>
        </el-table-column>
        <el-table-column prop="serialNumber" label="No." width="50" align="center">
          <template v-slot="scope">
            <span style="display: block; padding-bottom: 10px;">{{ scope.row.serialNumber === 999 ? '' : scope.$index  + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predecessorTaskNumber" label="Predecessor Task" width="80">
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.predecessorTaskNumber'">
              <el-input-number
                :precision="0"
                :controls="false"
                v-model="scope.row.predecessorTaskNumber"
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                maxlength="255"
                clearable
                :title="scope.row.predecessorTaskNumber"
                placeholder=""
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="criticalMilestone" min-width="150">
          <template slot="header">
            <span class="hasStar">Key Milestone<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.criticalMilestone'" :rules="{ required: true, message: 'Please select' }">
              <el-select clearable v-model="scope.row.criticalMilestone" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in yesOrNo"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="missionCritical" min-width="180">
          <template slot="header">
            <span class="hasStar">Key Task<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.missionCritical'" :rules="{ required: true, message: 'Please input' }">
              <el-input v-model="scope.row.missionCritical" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" :title="scope.row.missionCritical" clearable></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="missionCriticalDesc:" min-width="180">
          <template slot="header">
            <span class="hasStar">Key Task Description<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.missionCriticalDesc'" :rules="{ required: true, message: 'Please input' }">
              <el-input v-model="scope.row.missionCriticalDesc" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" :title="scope.row.missionCriticalDesc" clearable></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="progressRatio" min-width="190">
          <template slot="header">
            <span class="hasStar">Progress Percentage (%)<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.progressRatio'" :rules="{ required: true, message: 'Please input' }">
             <el-input-number clearable :min="0" :max="100" :controls="false" @change="changeProgressRatio" v-model="scope.row.progressRatio" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="workAttribute" min-width="180" >
          <template slot="header">
            <span class="hasStar">Work Attribute
              <span>*</span>
              <el-tooltip dangerouslyUseHTMLString="true" class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <strong>Mgmt.</strong>: Project management tasks such as project initiation, planning, implementation, monitoring, and acceptance.
                  <br/>
                  <strong>Delivery</strong>: The specific implementation work includes project design, installation, supervision and commissioning.
                </div>
                <i class="el-icon-question icon-label" />
              </el-tooltip>
            </span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.workAttribute'" :rules="{ required: scope.$index !== milestoneForm.tableData.length-1, message: 'Please select' }">
              <el-select clearable @change="changeLHA" v-model="scope.row.workAttribute" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in AttributeList"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="estimatedWorkload" label="Labor-hour Assessment（Person-day）" min-width="180">
          <template slot="header">
            <span class="hasStar">Labor-hour Assessment（Person-day）<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.estimatedWorkload'" :rules="{ required: true, message: 'Please input' }">
              <el-input-number clearable :min="0" :precision="2" :controls="false" @change="changeDays" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" v-model="scope.row.estimatedWorkload" />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="status" min-width="180">
          <template slot="header">
            <span class="hasStar">Current Status<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.status'" :rules="{ required: true, message: 'Please input' }">
              <el-select clearable v-model="scope.row.status" :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit" placeholder="">
                <el-option
                  v-for="item in milestoneStatus"
                  :key="item.labelKey"
                  :label="item.labelValue"
                  :value="item.labelKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" min-width="150">
          <template slot="header">
            <span class="hasStar">Start Date<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.startTime'" :rules="{ required: true, message: 'Please select' }">
              <el-date-picker
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                v-model="scope.row.startTime"
                type="date"
                value-format="yyyy-MM-dd" 
                placeholder=""
							  :picker-options="{ disabledDate: disabledStartDate }"
                @change="changStartTime"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" min-width="150">
          <template slot="header">
            <span class="hasStar">End Date<span>*</span></span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.endTime'" :rules="{ required: true, message: 'Please select' }">
              <el-date-picker
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
                v-model="scope.row.endTime"
                type="date"
                value-format="yyyy-MM-dd" 
                placeholder=""
							  :picker-options="{ disabledDate: disabledEndDate }"
                @change="changEndTime"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="taskLeader" min-width="180">
          <template slot="header">
            <span>Task Owner</span>
          </template>
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.taskLeader'" :rules="{ required: false, message: 'Please select' }">
              <el-select
                v-model="scope.row.taskLeader"
                multiple
                clearable
                filterable
                remote
                placeholder=""
                :filter-method="filterUser"
                :disabled="scope.$index === milestoneForm.tableData.length - 1 || !canEdit"
              >
                <el-option v-for="(item) in leaderList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="updatedTime" label="Update Date" min-width="180">
          <template v-slot="scope">
            <el-form-item :prop="'tableData.' + scope.$index + '.updatedTime'">
              <el-date-picker
                v-model="scope.row.updatedTime"
                type="date"
                value-format="yyyy-MM-dd" 
                placeholder=""
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'milestonePlanList',
  props: {
    id: {
      type: Number,
      default: null,
    },
    milestoneStatus: {
      type: Array,
      default: [],
    },
    AttributeList: {
      type: Array,
      default: []
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    projectPlanStartDate: {
      type: String,
      default: ''
    },
    projectPlanEndDate: {
      type: String,
      default: ''
    }
  },
  watch: {
  },
  data() {
    return {
      milestoneForm: {
        tableData: [],
      },
      riskLevel: [],
      leaderList: [],
      tableData: [],
      yesOrNo: [
        { labelKey: 1, labelValue: 'Yes' },
        { labelKey: 0, labelValue: 'No' }
      ],
      initUser: [],
      tableLoading: false,
      saveLoading: false,
      // canEdit: true,
      ganttData: [],
      isAdd: false,
    };
  },
  mounted() {
  },
  methods: {
    disabledStartDate(time) {
      if(!this.projectPlanStartDate) {
        return true;
      } else {
        const referenceTime = new Date(this.projectPlanStartDate).setHours(0, 0, 0, 0);
        const currentTime = time.getTime();
        return currentTime < referenceTime;
      }
    },
    disabledEndDate(time) {
      if(!this.projectPlanEndDate) {
        return true;
      } else {
         const referenceTime = new Date(this.projectPlanEndDate).setHours(23, 59, 59, 999);
          const currentTime = time.getTime();
          return currentTime > referenceTime;
      }
    },
    setData(newMilestoneList) {
      let milestoneNList = [];
      newMilestoneList.forEach(item => {
        milestoneNList.push({
          ...item,
          predecessorTaskNumber: item.predecessorTaskNumber === null ? undefined : item.predecessorTaskNumber,
          taskLeader: item.taskLeader ? item.taskLeader.split(',') : [],
          startTime: item.startTime ? moment(item.startTime).format('YYYY-MM-DD') : '',
          endTime: item.endTime ? moment(item.endTime).format('YYYY-MM-DD') : '',
        })
      })
      this.milestoneForm.tableData = milestoneNList;
      const allLeaders = milestoneNList.flatMap(entry => entry.taskLeader);
      this.initUser = [...new Set(allLeaders)];
      this.$nextTick(() => {
        this.$refs.milestoneForm.clearValidate();
      });
      if (this.initUser && this.initUser.length > 0) {
        let obj = {
          empCodeList: this.initUser
        }
				let url =`${this.$store.state.islhurl}user/batch-get`;
        this._post(url, obj).then(
          res => {  
            if(res.code === 200 && res.data) {
              this.leaderList = res.data
            }
          }
        )
      }
    },
    setLastData(majorProjectForm, keyPersonnelForm) {
      const length = this.milestoneForm.tableData.length;
      const lastInfo = length > 0 ? this.milestoneForm.tableData[length-1] : {};
      let info = {
        serialNumber: 999,
        criticalMilestone: 1,
        missionCritical: 'Overall Project Progress',
        missionCriticalDesc: 'Overall Project Progress',
        progressRatio: lastInfo.progressRatio || '0',
        estimatedWorkload: lastInfo.estimatedWorkload || 0,
        status: 2,
        // startTime: majorProjectForm.projectPlanStartDate ? majorProjectForm.projectPlanStartDate : '',
        // endTime: majorProjectForm.projectPlanEndDate ? majorProjectForm.projectPlanEndDate : '',
        taskLeader: [keyPersonnelForm.projectManager] || [],
      }
      if(this.milestoneForm.tableData.length === 0) {
        this.milestoneForm.tableData = [
          {taskLeader: []},
          {...info},
        ]
      } else {
        this.$set(this.milestoneForm.tableData, length - 1, {
          ...this.milestoneForm.tableData[length - 1],
          ...info,
        })
      }
      const allLeaders = this.milestoneForm.tableData.flatMap(entry => entry.taskLeader);
      this.initUser = [...new Set(allLeaders)];
      if (this.initUser && this.initUser.length > 0) {
        let obj = {
          empCodeList: this.initUser
        }
				let url =`${this.$store.state.islhurl}user/batch-get`;
        this._post(url, obj).then(
          res => {  
            if(res.code === 200 && res.data) {
              this.leaderList = res.data
            }
          }
        )
      }
    },
    filterUser(query) {
      if (query !== '') {
        // 清除之前的定时器
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        // 防抖处理，300ms后执行
        this.timeout = setTimeout(() => {
          this.fetchUserOptions(query)
        }, 200)
      } else {
        this.leaderList = [];
      }
    },
    fetchUserOptions(query) {
      let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
      this._get(url).then().then(res => {
        if(res.code === 200 && res.data) {
          this.leaderList = res.data;
        } else {
          this.leaderList = [];
        }
      }).catch(error => {
        this.leaderList = [];
        console.error('搜索失败:', error)
      })
    },
    addRow(index) {
			this.milestoneForm['tableData'].splice(index + 1, 0, { taskLeader: []});
      this.$nextTick(() => {
        this.$refs.milestoneForm.clearValidate();
      });
    },
    deleteRow(row, index) {
      this.milestoneForm['tableData'].splice(index, 1);
      this.changeProgressRatio();
      this.changeDays();
      this.changStartTime();
      this.changEndTime();
    },
    changeProgressRatio() {
      let allProgress = 0;
      const tableData = this.milestoneForm.tableData;
      tableData.forEach((item, index) => {
        if(tableData.length > 1 && index < tableData.length - 1) {
          allProgress += 1 / (tableData.length - 1) * (item.progressRatio || 0);
        }
      })
      const newLastData = tableData[tableData.length - 1];
      newLastData.progressRatio = allProgress.toFixed(2);
      this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData)
    },
    changeDays() {
      let allDays = 0;
      const tableData = this.milestoneForm.tableData;
      tableData.forEach((item, index) => {
        if(tableData.length > 1 && index < tableData.length - 1) {
          allDays += (item.estimatedWorkload || 0);
        }
      })
      this.changeLHA();
      const newLastData = tableData[tableData.length - 1];
      newLastData.estimatedWorkload = allDays.toFixed(2);
      this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData)
      this.$emit('setDays', allDays.toFixed(2));
    },
    changeLHA() {
      let allMgmt = 0;
      let allDelivery = 0;
      const tableData = this.milestoneForm.tableData;
      tableData.forEach((item, index) => {
        if (tableData.length > 1 && index < tableData.length - 1) {
          if (item.workAttribute == 1) {
            allMgmt+=(item.estimatedWorkload||0)
          }
          if (item.workAttribute == 2) {
            allDelivery += (item.estimatedWorkload || 0)
          }
        }
      })
      const newLastData = tableData[tableData.length - 1];
      newLastData.allMgmt = allMgmt.toFixed(2);
      newLastData.allDelivery = allDelivery.toFixed(2);
      this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData)
      this.$emit('setMgmt', allMgmt.toFixed(2));
      this.$emit('setDelivery', allDelivery.toFixed(2));
    },
    changStartTime() {
      const tableData = this.milestoneForm.tableData;
      const tableNewData = this.milestoneForm.tableData.slice(0, -1);
      const validItems = tableNewData.filter(item => item.startTime !== null);
      if (validItems.length > 0) {
        const earliestItem = validItems.reduce((earliest, current) => 
          new Date(current.startTime) < new Date(earliest.startTime) ? current : earliest
        );
        const newLastData = tableData[tableData.length - 1];
        newLastData.startTime = earliestItem.startTime;
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      } else {
        const newLastData = tableData[tableData.length - 1];
        newLastData.startTime = '';
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      }
    },
    changEndTime() {
      const tableData = this.milestoneForm.tableData;
      const tableNewData = this.milestoneForm.tableData.slice(0, -1);
      const validItems = tableNewData.filter(item => item.endTime !== null);
      if (validItems.length > 0) {
        const latestItem = validItems.reduce((latest, current) => 
          new Date(current.endTime) > new Date(latest.endTime) ? current : latest
        );
        const newLastData = tableData[tableData.length - 1];
        newLastData.endTime = latestItem.endTime;
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      } else {
        const newLastData = tableData[tableData.length - 1];
        newLastData.endTime = '';
        this.$set(this.milestoneForm.tableData, tableData.length - 1, newLastData);
      }
    },
  },
}
</script>
<style lang="less" scoped>
.milestone-table {
	/deep/.cell {
    padding: 10px 8px 0 8px!important;
  }
  /deep/.el-table__header-wrapper .cell {
    padding: 8px!important;
  }
  /deep/.el-form-item {
    margin-bottom: 10px;
  }
  /deep/.el-form-item__error {
    padding-top: 0;
    top: 90%;
  }
  /deep/.el-form-item__content .el-input__suffix {
    left: initial;
    right: 5px;
  }
  /deep/.el-select {
    width: 100%;
  }
  /deep/.el-table__cell {
    padding: 0;
    .el-input__inner {
      padding: 0 8px;
    }
    .el-input-number {
      width: 100%;
      .el-input__inner {
        text-align: left;
      }
    }
    .el-date-editor .el-input__inner {
      padding-left: 30px;
    }
    .hasStar span {
      color: #F56C6C;
      padding-left: 1px;
    }
    .el-input__icon {
      line-height: inherit;
    }
  }
  /deep/tbody tr:last-child {
    background-color: #cfe4f9;
    .el-input.is-disabled .el-input__inner,
    .el-input__inner {
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectApplication/milestoneList.vue